import { render, staticRenderFns } from "./RegisterDiploma.vue?vue&type=template&id=bf0f0b90"
import script from "./RegisterDiploma.vue?vue&type=script&lang=js"
export * from "./RegisterDiploma.vue?vue&type=script&lang=js"
import style0 from "./RegisterDiploma.vue?vue&type=style&index=0&id=bf0f0b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports